<template>
  <div class="form-group document-url-input">
    <input 
      :value="value" 
      @input="$emit('input', $event.target.value)"
      class="form-control" 
      :placeholder="placeholder"
      type="text" 
    />
  </div>
</template>

<script>
export default {
  name: "DocumentUrlInput",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "https://www.example.com/document"
    }
  }
};
</script>

